export class PlanoCategoria {
    idCategoria: number;
    nmCategoria: string;
}